import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import Text from '../../../../shared/_TBComponents/Text';
import ShimmerWorkoutsListItem from '../../../workouts/components/presentational/ShimmerWorkoutsListItem';
import StandardWorkoutListItem from '../../../workouts/components/presentational/StandardWorkoutListItem';
import WorkoutBreakSection from '../../../workouts/components/presentational/WorkoutBreakSection';

const ReadOnlyWrapper = styled.div`
  pointer-events: none !important;
  cursor: default;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  & * {
    cursor: default !important;
  }
`;

const idGenerator = (item) => {
  if (item.assignedId) return item.assignedId;
  return item.saveDataId;
};

const indexGenerator = (dictionary, item) => dictionary[idGenerator(item)];

// Maps workout items to list components and handle break sections as grouped containers
const workoutsMapper = (workoutItemsArray = []) => {
  const { itemIndexMap } = workoutItemsArray.reduce(
    (acc, item) => {
      const itemId = idGenerator(item);
      acc.itemIndexMap[itemId] = acc.idx;
      acc.idx += 1;
      if (item.type === 'BR') {
        (item.sessionBreakItems ?? []).forEach((sessionBreakItem) => {
          const sessionBreakItemId = idGenerator(sessionBreakItem);
          acc.itemIndexMap[sessionBreakItemId] = acc.idx;
          acc.idx += 1;
        });
      }
      return acc;
    },
    { itemIndexMap: {}, idx: 0 },
  );
  return workoutItemsArray.map((item, index) => {
    if (item.type !== 'BR') {
      const nextItem = workoutItemsArray[index + 1];
      const showVerticalLine = Boolean(nextItem) && nextItem?.type !== 'BR';
      return (
        <ReadOnlyWrapper key={idGenerator(item)} style={{ marginLeft: '-20px' }}>
          <StandardWorkoutListItem
            workoutItem={item}
            index={indexGenerator(itemIndexMap, item)}
            showVerticalLine={showVerticalLine}
          />
        </ReadOnlyWrapper>
      );
    }
    return (
      <WorkoutBreakSection
        key={idGenerator(item)}
        sectionHeader={item}
        section={item.sessionBreakItems}
        itemDictionary={itemIndexMap}
      />
    );
  });
};

const shimmerItemMapper = (workoutItemsArray) => workoutItemsArray.map((index) => (
  <ShimmerWorkoutsListItem
    showVerticalLine
    index={index}
  />
));

const PreviewCalendarList = ({
  workoutItems,
  isWorkoutsListLoading,
}) => {
  if (isWorkoutsListLoading) {
    return (
      <ReadOnlyWrapper>
        {shimmerItemMapper([1, 2, 3, 4, 5])}
      </ReadOnlyWrapper>
    );
  }
  if (workoutItems.length) {
    return workoutsMapper(workoutItems);
  }
  return (
    <Text
      styledTextProps={{ fontSize: '16px', color: '#9E9E9E' }}
      styledWrapperProps={{ margin: '6px 0 12px 12px' }}
    >
      No upcoming workouts scheduled
    </Text>
  );
};

PreviewCalendarList.propTypes = {
  workoutItems: PropTypes.arrayOf(
    PropTypes.shape({
      assignedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      saveDataId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      type: PropTypes.string,
    }),
  ).isRequired,
  isWorkoutsListLoading: PropTypes.bool.isRequired,
};

export default PreviewCalendarList;
